import React, { useEffect, useState, useContext } from "react";
import { ServerContext } from "../App";
import { getMatchesCard } from "../services/ScheduleService";
import CompletedMatchCard from "../components/Home/CompletedMatchCard";
import Pagination from "../components/shared/Pagination";

function Results() {
    const { selectedServerIds } = useContext(ServerContext);
    const [activeFilter, setActiveFilter] = useState("all");
    const [matches, setMatches] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const PAGE_SIZE = 10;

    const fetchData = (page, range) => {
        setLoading(true);
        getMatchesCard("completed", page, PAGE_SIZE, range, selectedServerIds).then((data) => {
            if (data && data.matches) {
                setMatches(data.matches);
                setTotalPages(data.totalPages);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchData(0, activeFilter);
        const interval = setInterval(() => fetchData(currentPage, activeFilter), 30000);
        return () => clearInterval(interval);
    }, [selectedServerIds]);

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        setCurrentPage(0);
        fetchData(0, filter);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, activeFilter);
    };

    return (
        <div id="section-results" className={`spanel active ${loading ? "page-loading" : "page-default"}`}>
            <div className="main-wrap main-wrap-padded">
                <div className="fbar">
                    <button className={`fbtn ${activeFilter === "all" ? "active" : ""}`} onClick={() => handleFilterChange("all")}>All</button>
                    <button className={`fbtn ${activeFilter === "today" ? "active" : ""}`} onClick={() => handleFilterChange("today")}>Today</button>
                    <button className={`fbtn ${activeFilter === "week" ? "active" : ""}`} onClick={() => handleFilterChange("week")}>This Week</button>
                </div>
                <div className="sh">All Results</div>

                {loading && (
                    <p className="no-matches-msg">Loading...</p>
                )}
                {!loading && matches.length === 0 && (
                    <p className="no-matches-msg">No results found.</p>
                )}

                {matches.map((match) => (
                    <CompletedMatchCard key={match.matchId} match={match} />
                ))}

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default Results;